import React, { useState } from 'react';
import { getFaqsByCategory } from '../../data/dealerFaqs';
import './FaqView.css';

const FaqView: React.FC = () => {
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set());
  const faqsByCategory = getFaqsByCategory();

  const toggleExpanded = (id: string) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedItems(newExpanded);
  };

  const expandAll = () => {
    const allIds = Object.values(faqsByCategory).flat().map(faq => faq.id);
    setExpandedItems(new Set(allIds));
  };

  const collapseAll = () => {
    setExpandedItems(new Set());
  };

  return (
    <div className="faq-view">
      <div className="faq-header">
        <div className="faq-title-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">
            Common questions about your advertising reports and data
          </p>
        </div>
        <div className="faq-controls">
          <button onClick={expandAll} className="faq-control-btn">
            <i className="material-icons">expand_more</i>
            Expand All
          </button>
          <button onClick={collapseAll} className="faq-control-btn">
            <i className="material-icons">expand_less</i>
            Collapse All
          </button>
        </div>
      </div>

      <div className="faq-content">
        {Object.entries(faqsByCategory).map(([category, faqs]) => (
          <div key={category} className="faq-category">
            <h3 className="faq-category-title">{category}</h3>
            <div className="faq-items">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className={`faq-item ${expandedItems.has(faq.id) ? 'expanded' : ''}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleExpanded(faq.id)}
                    aria-expanded={expandedItems.has(faq.id)}
                  >
                    <span className="faq-question-text">{faq.question}</span>
                    <i className="material-icons faq-expand-icon">
                      {expandedItems.has(faq.id) ? 'expand_less' : 'expand_more'}
                    </i>
                  </button>
                  {expandedItems.has(faq.id) && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="faq-contact">
        <div className="faq-contact-card">
          <div className="faq-contact-icon">
            <i className="material-icons">support_agent</i>
          </div>
          <div className="faq-contact-content">
            <h4>Still have questions?</h4>
            <p>Contact your marketing coordinator or account manager for personalized help with your campaigns and reporting.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqView;